import { WarningIcon } from '@capsicum/common-web/icons';
import { WalletConnectErrors, WalletConnectEvents } from '@socios-blk/core';

import type { TranslationIDs } from '@capsicum/common';

export const WALLET_CONNECT_ERRORS_MAP = {
	[WalletConnectErrors.ALREADY_PAIRED]: {
		title: 'ncWallet.walletConnect.error.alreadyPaired'
	},
	[WalletConnectErrors.EXPIRED_TOKEN_ERROR]: {
		description: 'ncWallet.walletConnect.error.expiredTokenDescription',
		title: 'ncWallet.walletConnect.error.expiredToken'
	},
	[WalletConnectErrors.INVALID_URI]: {
		title: 'ncWallet.walletConnect.error.invalidUriTitle'
	},
	[WalletConnectErrors.PAIRING_ERROR]: {
		title: 'error.default'
	},
	[WalletConnectErrors.SESSION_PROPOSAL_MISMATCH]: {
		title: 'ncWallet.walletConnect.error.sessionProposalMismatch'
	},
	[WalletConnectErrors.SESSION_TOPIC_NOT_FOUND]: {
		title: 'ncWallet.walletConnect.error.sessionTopicNotFound'
	}
} as Record<WalletConnectErrors, { description?: TranslationIDs; title: TranslationIDs }>;

export const WALLET_CONNECT_EVENTS_MAP = {
	[WalletConnectEvents.PAIRING_SUCCESS]: {
		description: 'ncWallet.walletConnect.notification.pairingSuccessDescription',
		title: 'ncWallet.walletConnect.notification.pairingSuccessTitle'
	},
	[WalletConnectEvents.TRANSACTION_SUCCESS]: {
		description: 'ncWallet.walletConnect.notification.transactionSuccessDescription',
		title: 'ncWallet.walletConnect.notification.transactionSuccessTitle'
	}
} as Record<WalletConnectEvents, { description: TranslationIDs; title: TranslationIDs }>;

export const DOMAIN_VERIFICATION_ALERT_TYPES = {
	INVALID: {
		icon: WarningIcon,
		subTitle: 'ncWallet.walletConnect.domainRisk.mismatchDescription',
		title: 'ncWallet.walletConnect.domainRisk.mismatchTitle',
		type: 'warning'
	},
	RISK: {
		icon: WarningIcon,
		subTitle: 'ncWallet.walletConnect.domainRisk.riskDescription',
		title: 'ncWallet.walletConnect.domainRisk.riskTitle',
		type: 'warning'
	},
	UNKNOWN: {
		icon: WarningIcon,
		subTitle: 'ncWallet.walletConnect.domainRisk.unknownDescription',
		title: 'ncWallet.walletConnect.domainRisk.unknownTitle',
		type: 'important'
	}
} satisfies Record<
	'INVALID' | 'RISK' | 'UNKNOWN',
	{
		icon: React.FC;
		subTitle: TranslationIDs;
		title: TranslationIDs;
		type: 'important' | 'success' | 'warning';
	}
>;
